import React from 'react';

const basePlans = [
  {
    name: 'Gym Access',
    price: '60 EUR / month',
    notes: ['Free weights + machines', 'Open gym access', 'Best for self-guided training'],
  },
  {
    name: 'Classes Only',
    price: '75 EUR / month',
    notes: ['Group classes only', 'Coach-led sessions', 'No open-gym access included'],
  },
  {
    name: 'Gym + Classes',
    price: '95 EUR / month',
    notes: ['Unlimited gym', 'Glutes & Abs', 'Circuit Functional', 'Box Fit', 'Conditioning'],
  },
  {
    name: 'Full Access',
    price: '120 EUR / month',
    notes: ['Gym + classes + spin', 'All-in-one membership', 'Best value for total access'],
  },
];

const spinPlans = [
  { name: 'Spin Pass', price: '12 EUR / day' },
  { name: '10 Spin Sessions', price: '100 EUR' },
  { name: 'Unlimited Spin', price: '95 EUR / month' },
];

export default function MebershipsTesting() {
  const gymOnlyBilling = [
    { label: '1 Month', price: '60 EUR' },
    { label: '3 Months', price: '165 EUR' },
    { label: '6 Months', price: '300 EUR' },
    { label: '1 Year', price: '540 EUR' },
  ];

  return (
    <main className="py-5">
      <section className="py-4 py-md-5 border-bottom">
        <div className="container">
          <h1 className="display-5 fw-bold mb-3">Meberships testing</h1>
          <p className="text-body-secondary mb-0">
            Hidden test page for trying different layouts to present your gym plans.
          </p>
        </div>
      </section>

      <section className="py-5 bg-body-secondary border-bottom">
        <div className="container">
          <h2 className="h3 text-center mb-4">Section 1 - Clean Membership Cards</h2>
          <div className="row g-4">
            {basePlans.map((plan) => (
              <div key={plan.name} className="col-12 col-md-6 col-xl-3">
                <article className="card h-100 shadow-sm border-0">
                  <div className="card-body d-flex flex-column">
                    <h3 className="h5">{plan.name}</h3>
                    <p className="display-6 fw-bold mb-3">{plan.price}</p>
                    <ul className="small text-body-secondary mb-0">
                      {plan.notes.map((note) => (
                        <li key={note} className="mb-1">
                          {note}
                        </li>
                      ))}
                    </ul>
                  </div>
                </article>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-5 border-bottom">
        <div className="container">
          <h2 className="h3 text-center mb-4">Section 2 - Spin Packages</h2>
          <div className="row justify-content-center g-3">
            {spinPlans.map((spin) => (
              <div key={spin.name} className="col-12 col-md-4">
                <div className="card h-100 text-center border-0 shadow-sm">
                  <div className="card-body d-flex flex-column justify-content-center">
                    <p className="text-uppercase small fw-semibold text-body-secondary mb-2">{spin.name}</p>
                    <p className="h3 mb-0 fw-bold">{spin.price}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-5 bg-body-secondary border-bottom">
        <div className="container">
          <h2 className="h3 text-center mb-4">Section 3 - Comparison Table</h2>
          <div className="table-responsive">
            <table className="table table-bordered align-middle bg-white">
              <thead className="table-light">
                <tr>
                  <th scope="col">Plan</th>
                  <th scope="col">Price</th>
                  <th scope="col">Gym Access</th>
                  <th scope="col">Classes</th>
                  <th scope="col">Spin</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Gym Access</td>
                  <td>60 EUR / month</td>
                  <td>Yes</td>
                  <td>No</td>
                  <td>No</td>
                </tr>
                <tr>
                  <td>Classes Only</td>
                  <td>75 EUR / month</td>
                  <td>No</td>
                  <td>Yes</td>
                  <td>No</td>
                </tr>
                <tr>
                  <td>Gym + Classes</td>
                  <td>95 EUR / month</td>
                  <td>Yes</td>
                  <td>Yes</td>
                  <td>No</td>
                </tr>
                <tr>
                  <td>Full Access</td>
                  <td>120 EUR / month</td>
                  <td>Yes</td>
                  <td>Yes</td>
                  <td>Yes</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container">
          <h2 className="h3 text-center mb-4">Section 4 - Featured Offers</h2>
          <div className="row g-4 justify-content-center">
            <div className="col-12 col-lg-5">
              <div className="p-4 rounded-3 bg-dark text-white h-100">
                <p className="text-uppercase small mb-2">Popular</p>
                <h3 className="h2 fw-bold">Gym + Classes</h3>
                <p className="display-6 fw-bold mb-2">95 EUR / month</p>
                <p className="mb-0 text-white-50">Unlimited gym plus all core class formats.</p>
              </div>
            </div>
            <div className="col-12 col-lg-5">
              <div className="p-4 rounded-3 border h-100">
                <p className="text-uppercase small mb-2 text-body-secondary">Premium</p>
                <h3 className="h2 fw-bold">Full Access</h3>
                <p className="display-6 fw-bold mb-2">120 EUR / month</p>
                <p className="mb-0 text-body-secondary">Gym + classes + spin in one membership.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5 bg-body-secondary border-top min-vh-100 d-flex align-items-center">
        <div className="container">
          <div className="row g-4 g-lg-5 align-items-stretch section5-membership-grid">
            <div className="col-12 col-xl-6">
              <div className="membership-hero-card h-100 p-4 p-md-5 p-xl-6">
                <p className="membership-kicker mb-2">Most Flexible</p>
                <h3 className="display-6 fw-bold mb-2">Gym Only</h3>
                <p className="lead mb-4 text-white-50">Unlimited access to the gym floor and equipment.</p>

                <div className="row g-3 mb-4">
                  {gymOnlyBilling.map((item) => (
                    <div key={item.label} className="col-6">
                      <div className="billing-option-box h-100">
                        <p className="small text-uppercase mb-1 text-white-50">{item.label}</p>
                        <p className="h5 fw-bold mb-0">{item.price}</p>
                      </div>
                    </div>
                  ))}
                </div>

                <ul className="mb-0 text-white-50">
                  <li>Unlimited gym floor access</li>
                  <li>Free weights and machines</li>
                  <li>Independent training support</li>
                </ul>
              </div>
            </div>

            <div className="col-12 col-md-6 col-xl-3">
              <div className="rounded-3 border shadow-sm p-4 p-md-5 p-xl-6 h-100 membership-plan-card membership-plan-card--classes">
                <p className="membership-card-kicker mb-2">Coach Led</p>
                <h3 className="h3 fw-bold mb-2">Classes Only</h3>
                <p className="membership-price mb-4">75 EUR / month</p>
                <p className="small text-uppercase text-body-secondary mb-2 fw-semibold">Options</p>
                <ul className="mb-0 membership-options-list">
                  <li>Access to all group classes</li>
                  <li>Coach-led sessions</li>
                  <li>Structured weekly training schedule</li>
                </ul>
              </div>
            </div>

            <div className="col-12 col-md-6 col-xl-3">
              <div className="rounded-3 border shadow-sm p-4 p-md-5 p-xl-6 h-100 membership-plan-card membership-plan-card--combo">
                <p className="membership-card-kicker mb-2">Best Seller</p>
                <h3 className="h3 fw-bold mb-2">Gym &amp; Classes Combo</h3>
                <p className="membership-price mb-4">95 EUR / month</p>
                <p className="small text-uppercase text-body-secondary mb-2 fw-semibold">Options</p>
                <ul className="mb-0 membership-options-list">
                  <li>Unlimited gym access</li>
                  <li>Glutes &amp; Abs</li>
                  <li>Circuit Functional</li>
                  <li>Box Fit</li>
                  <li>Conditioning</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5 border-top bg-body-secondary">
        <div className="container">
          <h2 className="h3 text-center mb-4">Section 6 - Memberships Carousel</h2>

          <div
            id="membershipCarousel"
            className="carousel slide membership-carousel"
            data-bs-ride="false"
            data-bs-interval="false"
          >
            <div className="carousel-inner">
              {basePlans.map((plan, idx) => (
                <div key={plan.name} className={`carousel-item ${idx === 0 ? 'active' : ''}`}>
                  <div className="row justify-content-center">
                    <div className="col-12 col-lg-10 col-xl-8">
                      <div className="card border-0 shadow-sm h-100 membership-card">
                        <div className="card-body p-4 p-md-5 d-flex flex-column">
                          <div className="d-flex align-items-start justify-content-between gap-3 flex-wrap">
                            <div>
                              <h3 className="h2 fw-bold mb-2">{plan.name}</h3>
                              <div className="text-body-secondary small mb-3">Membership plan</div>
                            </div>
                            <div className="text-end">
                              <div className="display-6 fw-bold">{plan.price}</div>
                            </div>
                          </div>

                          <div className="mt-3">
                            <div className="small text-uppercase text-body-secondary fw-semibold mb-2">
                              What you get
                            </div>
                            <ul className="mb-0">
                              {plan.notes.map((note) => (
                                <li key={note} className="mb-2">
                                  {note}
                                </li>
                              ))}
                            </ul>
                          </div>

                          <div className="mt-auto pt-4 text-center">
                            <a href="#test" className="btn btn-dark">
                              Choose this plan
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#membershipCarousel"
              data-bs-slide="prev"
            >
              <span className="carousel-control-prev-icon" aria-hidden="true" />
              <span className="visually-hidden">Previous</span>
            </button>
            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#membershipCarousel"
              data-bs-slide="next"
            >
              <span className="carousel-control-next-icon" aria-hidden="true" />
              <span className="visually-hidden">Next</span>
            </button>
          </div>
        </div>
      </section>
    </main>
  );
}
